import React, { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Spinner from 'react-spinkit';


class LoadingSpinner extends PureComponent {
    static FADE_IN_FULL = 'full';
    static FADE_IN_HALF = 'half';
    static FADE_IN_QUARTER = 'quarter';
    static FADE_IN_NONE = 'none';

    render() {
        return (
            <div className={classNames("LoadingSpinner", this.props.className)}>
                {this.props.isEnableSpinner && (
                    <Spinner className="LoadingSpinner-element" fadeIn={this.props.fadeIn} name={this.props.name} />
                )}
            </div>
        );
    }
}

LoadingSpinner.defaultProps = {
    isEnableSpinner: true,
    name: 'line-scale-pulse-out',
    className: '',
    fadeIn: LoadingSpinner.FADE_IN_FULL
};

LoadingSpinner.propTypes = {
    isEnableSpinner: PropTypes.bool,
    name: PropTypes.string,
    className: PropTypes.string,
    fadeIn: PropTypes.string,
};

export default LoadingSpinner;